import revealOnScroll from "../utils/revealOnScroll"

class TeamCards {
	constructor(selector = ".team-card") {
		this.cards = Array.from(document.querySelectorAll(selector))

		this.init()
	}

	init() {
		if (!this.cards.length) {
			return
		}

		revealOnScroll(this.cards, {
			stagger: 150,
			visibleClass: "visible",
			observerOptions: {
				rootMargin: "0px 0px -80px 0px",
				threshold: 0.15
			}
		})
	}
}

export default TeamCards
